import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';
import RecognizedIcon from 'dibs-vg/dist/react/recognized-ribbon';
import TopSellerIcon from 'dibs-vg/dist/react/diamond';
import VettedIcon from 'dibs-vg/dist/react/vetted-checkmark';

import {
    recognizedTitle,
    recognizedDescription,
    vettedTitle,
    vettedDescription,
    goldSellerTitle,
    platinumSellerTitle,
    tieredSellerDescription,
} from '../messages/pdpDistinctionsMessages';
import { PdpSharedDealerDistinction } from './PdpSharedDealerDistinction';
import styles from './PdpSharedDealerDistinctions.scss';

function PdpSharedDealerDistinctionsComponent({ seller, showDescriptions }) {
    const isRecognized = get(seller, 'isDistinguished');
    const sellerTierDataFound = !get(seller, 'sellerTiers.sellerTierDataNotFound');
    const isGoldSeller = sellerTierDataFound && get(seller, 'sellerTiers.isGoldTier');
    const isPlatinumSeller = sellerTierDataFound && get(seller, 'sellerTiers.isPlatinumTier');

    return (
        <div className={styles.container}>
            <PdpSharedDealerDistinction
                icon={VettedIcon}
                title={vettedTitle}
                description={showDescriptions && vettedDescription}
                dataTn="pdp-distinction-vetted"
            />
            {isRecognized && (
                <PdpSharedDealerDistinction
                    icon={RecognizedIcon}
                    title={recognizedTitle}
                    description={showDescriptions && recognizedDescription}
                    dataTn="pdp-distinction-recognized"
                />
            )}
            {isGoldSeller && (
                <PdpSharedDealerDistinction
                    icon={TopSellerIcon}
                    title={goldSellerTitle}
                    description={showDescriptions && tieredSellerDescription}
                    dataTn="pdp-distinction-gold-tier"
                />
            )}
            {isPlatinumSeller && (
                <PdpSharedDealerDistinction
                    icon={TopSellerIcon}
                    title={platinumSellerTitle}
                    description={showDescriptions && tieredSellerDescription}
                    dataTn="pdp-distinction-platinum-tier"
                />
            )}
        </div>
    );
}

PdpSharedDealerDistinctionsComponent.defaultProps = {
    showDescriptions: false,
};

PdpSharedDealerDistinctionsComponent.propTypes = {
    seller: PropTypes.object.isRequired,
    showDescriptions: PropTypes.bool,
};

export const PdpSharedDealerDistinctions = createFragmentContainer(
    PdpSharedDealerDistinctionsComponent,
    {
        seller: graphql`
            fragment PdpSharedDealerDistinctions_seller on Seller {
                isDistinguished
                sellerTiers {
                    isGoldTier
                    isPlatinumTier
                    sellerTierDataNotFound
                }
            }
        `,
    }
);
